export default __webpack_public_path__ + "images/logo-ilsco.svg?0eec9dc03cd429e37c9e3544891a2244";